import {
  Button,
  ButtonText,
  FormControl,
  FormControlLabel,
  FormControlLabelText,
  HStack,
  Input,
  InputField,
  Text,
  VStack,
} from "wealthmode-frontend/gluestack/ui"

/**
 * OverrideField edits one override. A null value is not blank - it means the
 * field is inherited from the provider connector currently serving the
 * connector, so the inherited value is shown alongside and reverting is just
 * clearing the override.
 */
export function OverrideField({
  label,
  value,
  inherited,
  onChange,
  placeholder,
  preview,
}: {
  label: string
  value: string | null
  inherited: string | null
  onChange: (value: string | null) => void
  placeholder?: string
  /** Rendered beside the input, for fields whose value is worth seeing. */
  preview?: React.ReactNode
}) {
  const overridden = value !== null

  return (
    <FormControl>
      <FormControlLabel>
        <FormControlLabelText>
          {label}{" "}
          {overridden ? (
            <Text className="text-xs text-foreground-secondary">
              Overridden. Reverting restores {inherited === null ? "an empty provider value" : `“${inherited}”`}.
            </Text>
          ) : (
            <Text className="text-xs text-foreground-secondary">Inherited from the provider.</Text>
          )}
        </FormControlLabelText>
      </FormControlLabel>
      <VStack className="gap-1">
        <HStack className="gap-2 items-center">
          {preview}
          <Input
            variant="outline"
            className="flex-1"
          >
            <InputField
              value={overridden ? value! : (inherited ?? "")}
              onChangeText={(text: string) => onChange(text)}
              placeholder={placeholder}
              autoCapitalize="none"
              autoCorrect={false}
            />
          </Input>
          <Button
            variant="outline"
            size="sm"
            isDisabled={!overridden}
            onPress={() => onChange(null)}
          >
            <ButtonText>Revert</ButtonText>
          </Button>
        </HStack>
      </VStack>
    </FormControl>
  )
}
